import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]
const _hoisted_2 = {
  class: "bg-gray-400 flex h-screen fixed w-full top-0 z-20 items-center justify-center",
  style: {'left': '0px'}
}
const _hoisted_3 = { class: "flex flex-col modal-box w-96" }
const _hoisted_4 = { class: "flex justify-end w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 11L11 1",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1L11 11",
    stroke: "#222B45",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Verify Number")
], -1)
const _hoisted_9 = { class: "px-5 py-15" }
const _hoisted_10 = { class: "very-light-text" }
const _hoisted_11 = { style: {'display': 'flex', 'flex-direction': 'row'} }
const _hoisted_12 = { class: "d-flex justify-center mt-5" }
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", {
    "max-width": 375,
    value: _ctx.OtpSrv.Mode
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.OtpSrv.cancel(), _ctx.hide)),
            class: "modal-button-close"
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.OtpSrv.Message), 1),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_v_otp_input, {
                ref: "otpInput",
                "input-classes": "otp-input",
                class: "rounded-sm otp-input",
                "num-inputs": 6,
                separator: "",
                "should-auto-focus": true,
                "is-input-num": true,
                modelValue: _ctx.OTP,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.OTP) = $event)),
                onOnComplete: _cache[2] || (_cache[2] = ($event: any) => {
                            _ctx.OtpSrv.verify($event);
                            _ctx.OTP = '';
                            }),
                disabled: !!_ctx.OtpSrv.Loading
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                disabled: !!_ctx.OtpSrv.Seconds,
                class: "flex justify-center px-10",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OtpSrv.resend())),
                text: "",
                style: {'display': 'flex', 'margin-left': 'auto', 'margin-right': 'auto'}
              }, [
                _createElementVNode("h1", {
                  style: _normalizeStyle(_ctx.timer ? {'color': 'rgba(0, 0, 0, 0.87)', 'background-color': '#fff'}: {'color': '#ed5151'})
                }, "Resend OTP", 4),
                _createTextVNode(" " + _toDisplayString(_ctx.timer ? `(in ${_ctx.timer} seconds)` : ``), 1)
              ], 8, _hoisted_13)
            ])
          ])
        ])
      ]),
      _createVNode(_component_loading, {
        absolute: "",
        active: _ctx.OtpSrv.Loading,
        class: "rounded fixed",
        opacity: "1",
        "is-full-page": _ctx.fullPage,
        style: {'left': '48%', 'top': '45%'}
      }, null, 8, ["active", "is-full-page"])
    ])
  ], 8, _hoisted_1))
}